import React from 'react';
import FlowFooter from './FlowFooter';

export function CoverageConsentFooter({
  onBack,
  onSubmit,
  submitTestId = 'continue-button-4',
}) {
  return <FlowFooter
    onBack={onBack}
    onNext={onSubmit}
    primaryButtonProps={{'data-testid': submitTestId}}
  />;
}
